<template>
  <Popover class="relative top-0 left-0">
    <PopoverButton
      class="text-button-small focus:outline-none focus:shadow-none"
    >
      <btn-primary size="small" :title="popoverButtonTitle" icon="angle-dawn" />
    </PopoverButton>

    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-2 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="-translate-y-2 opacity-0"
    >
      <PopoverPanel
        ref="tpl_popoverPanel"
        v-slot="{ close }"
        class="absolute top-auto -right-2 bottom-8 left-auto z-10"
      >
        <div
          ref="tpl_popoverPanelContent"
          class="flex flex-col items-end gap-md bg-skin-inverted text-skin-inverted p-xl"
          v-intersection-observer="
            ([{ isIntersecting }]) =>
              onIntersectionObserver(isIntersecting, close)
          "
        >
          <div class="text-boody-small whitespace-nowrap">
            {{ $t.change_language }}
          </div>
          <btn-primary
            size="small"
            to="/en"
            :title="$t.language_english"
            :disabled="$route.params.locale === 'en'"
            :class="{
              '[&>*]:!text-skin-inverted': $route.params.locale !== 'en',
            }"
            @click.stop.prevent="changeLanguage('en')"
          />

          <btn-primary
            size="small"
            to="/en-us"
            :title="$t.language_english_american"
            :disabled="$route.params.locale === 'en-us'"
            :class="{
              '[&>*]:!text-skin-inverted': $route.params.locale !== 'en-us',
            }"
            @click.stop.prevent="changeLanguage('en-us')"
          />

          <btn-primary
            size="small"
            to="/it"
            :title="$t.language_italian"
            :disabled="$route.params.locale === 'it'"
            :class="{
              '[&>*]:!text-skin-inverted': $route.params.locale !== 'it',
            }"
            @click.stop.prevent="changeLanguage('it')"
          />

          <btn-primary
            size="small"
            to="/de"
            :title="$t.language_german"
            :disabled="$route.params.locale === 'de'"
            :class="{
              '[&>*]:!text-skin-inverted': $route.params.locale !== 'de',
            }"
            @click.stop.prevent="changeLanguage('de')"
          />

          <btn-primary
            size="small"
            to="/fr"
            :title="$t.language_french"
            :disabled="$route.params.locale === 'fr'"
            :class="{
              '[&>*]:!text-skin-inverted': $route.params.locale !== 'fr',
            }"
            @click.stop.prevent="changeLanguage('fr')"
          />

          <btn-primary
            size="small"
            to="/es"
            :title="$t.language_spanish"
            :disabled="$route.params.locale === 'es'"
            :class="{
              '[&>*]:!text-skin-inverted': $route.params.locale !== 'es',
            }"
            @click.stop.prevent="changeLanguage('es')"
          />
          <!--
          <btn-primary
            size="small"
            to="/ko"
            :title="$t.language_korean"
            :disabled="$route.params.locale === 'ko'"
            :class="{
              '[&>*]:!text-skin-inverted': $route.params.locale !== 'ko',
            }"
            @click.stop.prevent="changeLanguage('ko')"
          />

          <btn-primary
            size="small"
            to="/ja"
            :title="$t.language_japanese"
            :disabled="$route.params.locale === 'ja'"
            :class="{
              '[&>*]:!text-skin-inverted': $route.params.locale !== 'ja',
            }"
            @click.stop.prevent="changeLanguage('ja')"
          />
          -->
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { vIntersectionObserver } from "@vueuse/components";

const { $t } = useNuxtApp();

const tpl_popoverPanel = ref(null);
const tpl_popoverPanelContent = ref(null);

const route = useRoute();

// maxAge 1 year: 60 * 60 * 24 * 365
const bebstLocale = useCookie("bebce_locale", { maxAge: 60 * 60 * 24 * 365 });

const popoverButtonTitle = computed(() => {
  let s;
  switch (route.params.locale) {
    case "en":
      s = $t.language_english_shortform;
      break;

    case "en-us":
      s = $t.language_english_american_shortform;
      break;

    case "it":
      s = $t.language_italian_shortform;
      break;

    case "de":
      s = $t.language_german_shortform;
      break;

    case "fr":
      s = $t.language_french_shortform;
      break;

    case "es":
      s = $t.language_spanish_shortform;
      break;

    case "ko":
      s = $t.language_korean_shortform;
      break;

    case "ja":
      s = $t.language_japanese_shortform;
      break;

    default:
      s = "/";
      break;
  }
  return s;
});

function onIntersectionObserver(isIntersecting, close) {
  if (!isIntersecting) {
    close();
  }
}
function changeLanguage(locale) {
  bebstLocale.value = locale;

  window.location = route.fullPath.replace(
    `/${route.params.locale}`,
    `/${locale}`
  );
}
</script>
